var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FF8A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5434 4.29126C7.34789 4.48544 7.25013 4.72168 7.25013 5C7.25013 5.27832 7.34789 5.51456 7.5434 5.70874C7.73891 5.90291 7.97449 6 8.25013 6C8.52577 6 8.76135 5.90291 8.95686 5.70874C9.15237 5.51456 9.25013 5.27832 9.25013 5C9.25013 4.72168 9.15237 4.48544 8.95686 4.29126C8.76135 4.09709 8.52577 4 8.25013 4C7.97449 4 7.73891 4.09709 7.5434 4.29126Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.59H10.5V11.59H6V10.59H7.5V7.59003H6.03014V6.59003H9V10.59Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipOrange);
export default __webpack_public_path__ + "static/media/tooltip-orange.61190cacd24e871e6b502d02d609f63b.svg";
export { ForwardRef as ReactComponent };